export function moveHighlightIndex({ options, fromIndex, delta }) {
  const list = options ?? [];
  if (list.length === 0) return fromIndex;

  let next = fromIndex;
  for (let i = 0; i < list.length; i += 1) {
    next = (next + delta + list.length) % list.length;
    if (!list[next]?.disabled) return next;
  }

  return fromIndex;
}
